import { render, staticRenderFns } from "./BankAccountForm.vue?vue&type=template&id=21799326&scoped=true"
import script from "./BankAccountForm.vue?vue&type=script&lang=ts"
export * from "./BankAccountForm.vue?vue&type=script&lang=ts"
import style0 from "./BankAccountForm.vue?vue&type=style&index=0&id=21799326&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21799326",
  null
  
)

export default component.exports